// constant.js

export const API_URL = "https://my-portfolio-psi-neon.vercel.app";

export const API_ROUTES = {
  PROJETS: `${API_URL}/projets`,

  users: `${API_URL}/users`,
  usersId: `${API_URL}/users/:id`,
  login: `${API_URL}/users/login`,
  checkToken: `${API_URL}/users/checkToken`,
  contact: `${API_URL}/contact`,
  admin: `${API_URL}/admin`,
};
